import { Canvas } from '@react-three/fiber'
import { Suspense, useEffect, useRef } from 'react'
import { EnvironmentMorph } from './EnvironmentMorph'
import { ParticleField } from './ParticleField'
import { VirtualChair } from './VirtualChair'
import { PostFX } from './PostFX'
import { AdaptiveQuality } from './AdaptiveQuality'
import { useExperienceStore } from '../store/experienceStore'
import { QUALITY_PRESETS } from '../config/quality'
import { Z_STACK } from '../config/layout'

function Scene() {
  return (
    <>
      <color attach="background" args={['#05060a']} />
      <ambientLight intensity={0.35} />
      <directionalLight position={[4, 8, 2]} intensity={0.6} color="#cdefff" />
      <pointLight position={[0, 2, 3]} intensity={0.4} color="#88ccff" />
      <EnvironmentMorph />
      <ParticleField />
      <VirtualChair />
      <PostFX />
      <AdaptiveQuality />
    </>
  )
}

export function ExperienceCanvas() {
  const quality = useExperienceStore((s) => s.quality)
  const dprCap = QUALITY_PRESETS[quality].pixelRatioCap
  const readySet = useRef(false)

  useEffect(() => {
    if (!readySet.current) {
      readySet.current = true
      // Mark interactive once canvas mounts — progressive assets continue loading
      useExperienceStore.getState().setReady(true)
      useExperienceStore.getState().setLoadProgress(0.4)
    }
  }, [])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: Z_STACK.canvas,
        background: '#05060a',
        width: '100vw',
        height: '100vh',
      }}
    >
      <Canvas
        dpr={[1, dprCap]}
        gl={{
          antialias: true,
          powerPreference: 'high-performance',
          alpha: false,
        }}
        camera={{ position: [0, 0.2, 4.5], fov: 55, near: 0.1, far: 200 }}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100vw',
          height: '100vh',
          display: 'block',
        }}
        resize={{ scroll: false, debounce: 0 }}
        onCreated={({ gl, setSize }) => {
          const w = Math.max(window.innerWidth || 1280, 1)
          const h = Math.max(window.innerHeight || 720, 1)
          setSize(w, h)
          gl.setSize(w, h, false)
        }}
      >
        <Suspense fallback={null}>
          <Scene />
        </Suspense>
      </Canvas>
    </div>
  )
}
